// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rvv6","newExpiryDate":"styles_newExpiryDate__TrkCj","footer":"styles_footer__2zVtu"};